import {logEvent} from '@yandex-delivery/modules/rum'
// @ts-ignore
import TJSON from '@yandex-int/yandex-tjson'
import React, {ReactNode} from 'react'

import {Placeholder, Translator} from './types'

type LanguageData = Record<string, unknown>

type PrintOptions = {
  count?: number
  placeholder?: Placeholder
  fallBackToKey?: boolean
}

const parseLang = (language: string): {lang?: string; dialect?: string} => {
  const [lang, dialect] = language.split('-')
  return {lang, dialect}
}

export const applyPlaceholder = (value: string, placeholders: Placeholder): ReactNode | string => {
  let hasReactElements = false
  const nodes = value.split(/([%][\w]+[%])/g).map(str => {
    const trimmedStr = str.substring(1, str.length - 1)
    const isPlaceholder = placeholders.hasOwnProperty(trimmedStr)
    if (isPlaceholder && React.isValidElement(placeholders[trimmedStr])) {
      hasReactElements = true
    }
    return isPlaceholder ? placeholders[trimmedStr] : str
  })

  return hasReactElements ? React.Children.toArray(nodes) : nodes.join('')
}

TJSON.prototype.print = function (key: string, printOptions: PrintOptions = {}) {
  const {count, fallBackToKey = true, placeholder} = printOptions
  const translationFromBunker = this.get(key, count)
  const translationWithFallback = translationFromBunker || (fallBackToKey ? key : undefined)

  if (process.env.NODE_ENV === 'production' && translationFromBunker === undefined) {
    logEvent('tanker_key_not_translated', key, printOptions)
  }

  return translationWithFallback && placeholder
    ? applyPlaceholder(translationWithFallback, placeholder)
    : translationWithFallback
}

/**
 * Импортирует кейсеты для языка
 * @param {object} data
 * @param {string} [language]
 * @returns {TJSON}
 */
TJSON.prototype.import = function (data: LanguageData, language: string) {
  language = language || this.state.language
  this.storage._langs[language] = data

  const {lang: originalLang, dialect} = parseLang(language)
  // в случае если локаль является диалектом,
  // нужно исходный объект с правилами плюрального преоброзования обогатить копией оригинального языка
  // иначе плюрпзилация работать не будет
  if (dialect && originalLang && !this.i18n[language]) {
    this.i18n[language] = this.i18n[originalLang]
  }
  return this
}

const t = (lang: string, translations: LanguageData, keySet = 'corp-client'): Translator => {
  const i18n = new TJSON()
    .import({[keySet]: translations}, lang)
    .lang(lang)
    .keyset(keySet)

  return function useI18n(key, paramsOrDefaultTranslation) {
    const secondParamIsString = typeof paramsOrDefaultTranslation === 'string'
    const translation = i18n.print(key, secondParamIsString ? undefined : paramsOrDefaultTranslation)

    return translation === key && secondParamIsString ? paramsOrDefaultTranslation : translation
  }
}
export default t
